module.exports = __webpack_public_path__ + "static/media/grap.8305092f.webp";